import { EnvironmentOutlined } from "@ant-design/icons"
import React from "react"
import { useTranslation } from "react-i18next"

import { BulkActionBar } from "../../components/Table/BulkActionBar.tsx"

// A single, no-modal action with no async result to report inline — a failed
// fetch surfaces as a plain toast, the convention `handleLocateMe` already
// uses on this page.
interface GlobalMapListBulkActionBarProps {
  selectedCount: number
  showOnMapDisabled?: boolean
  showOnMapLoading?: boolean
  onShowOnMap: () => void
  onClear: () => void
}

const GlobalMapListBulkActionBar = ({
  selectedCount,
  showOnMapDisabled,
  showOnMapLoading,
  onShowOnMap,
  onClear
}: GlobalMapListBulkActionBarProps) => {
  const { t } = useTranslation()

  return (
    <BulkActionBar
      data-testid="global-map-list-bulk-action-bar"
      positionClassName="sticky bottom-0 z-30"
      surface="page"
      selectedCount={selectedCount}
      selectedLabel={t("globalMap.list.bulkActions.selected", {
        count: selectedCount
      })}
      ariaLabel={t("globalMap.list.bulkActions.toolbarLabel")}
      actions={[
        {
          key: "show-on-map",
          label: t("globalMap.list.bulkActions.showOnMap"),
          icon: <EnvironmentOutlined aria-hidden />,
          disabled: showOnMapDisabled,
          disabledReason: t("globalMap.list.bulkActions.showOnMapDisabled"),
          loading: showOnMapLoading,
          onClick: onShowOnMap
        }
      ]}
      onClear={onClear}
    />
  )
}

export default GlobalMapListBulkActionBar
